import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, GridApi } from 'ag-grid-community';
import { faEdit, faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-action-cell-renderer',
  templateUrl: './action-cell-renderer.component.html',
  styleUrls: ['./action-cell-renderer.component.scss']
})
export class ActionCellRendererComponent implements ICellRendererAngularComp{
  faEdit = faEdit;
  faSave = faFloppyDisk;
  faCancel = faXmark;

  params!: ICellRendererParams;
  isEditing!: boolean;
  g!: GridApi;
  userModifiedData: any;

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
    this.isEditing = false;
    this.g = params.api;
    this.userModifiedData = params.context;
  }

  onClickEdit(){
    if(this.g){
      this.isEditing = true;
      console.log(this.params.node.data)
      const rowIndex = this.params.node.rowIndex
      if(rowIndex !== null){
        this.g.startEditingCell({
          rowIndex: rowIndex,
          colKey: 'lading_number'
        })
  
      }
    }
  }

  onClickCancel(){
    this.isEditing = false;
    this.g.stopEditing(true);
    // TO DO: REVERT CELL CHANGES
  }

  onClickSave(){
    this.isEditing = false;
    this.g.stopEditing(false);
    // TO DO: SEND CHANGES TO API
    this.userModifiedData = this.params.context.userModifiedData;
    console.log(this.userModifiedData);
  }

  refresh(params: ICellRendererParams): boolean{
    console.log("cell renderer refreshed")
    this.isEditing = false;
    this.userModifiedData = params.context.userModifiedData;
    console.log(this.userModifiedData);
    return true;
  }
}
